import { api } from "./backend";
import { listado } from "./listado";

export function crear() {
  return {
    id: 0,
    nombre: "",
    meses: 0,
    tipoDescuentoAsociado: "",
    defaultValue: 0,
  };
}

export function listar(params) {
  return listado("duracionContrato/listar", params);
}

export function combo() {
  return listar().then((duracionesContrato) => {
    return duracionesContrato.map((dc) => {
      return {
        text: dc.nombre,
        value: dc.id,
      };
    });
  });
}

export function cargar(id) {
  return api.get("duracionContrato/cargar&id=" + id).then((response) => {
    return response.data;
  });
}

export function insertar(duracionContrato) {
  return api.post("duracionContrato/insertar", { duracionContrato });
}

export function actualizar(duracionContrato) {
  return api.post("duracionContrato/actualizar", { duracionContrato });
}

export function eliminar(id) {
  return api.post("duracionContrato/eliminar", { id });
}

export function cargarModificadores(id) {
  return api.get("duracionContrato/cargarModificadores&id=" + id).then((response) => {
    return response.data;
  });
}

export function guardarModificador(modificador) {
  return api.post("duracionContrato/guardarModificador", { modificador });
}

export function eliminarModificador(id) {
  return api.post("duracionContrato/eliminarModificador", { id });
}
